import React from 'react';

//images
import Image from '../assets/avatar-1.png';

//icons
import { GrInstagram } from 'react-icons/gr';
import { FaFacebook, FaLinkedin, FaGithub } from 'react-icons/fa';

//type animation
import { TypeAnimation } from 'react-type-animation';

//motion
import { motion } from 'framer-motion';

//variants
import { fadeIn } from '../variants';

//link
import { Link } from 'react-scroll';


const Banner = () => (
  <section id='home' className='min-h-[75vh] lg:min-h-[78vh] flex items-center'>
    <div className='container mx-auto'>
      <div className='flex flex-col gap-y-8 lg:flex-row lg:items-center lg:gap-x-4'>

        {/* text */}
        <div className='flex-1 text-center font-secondary lg:text-left'>
          <motion.h2 variants={fadeIn('up', 0.2)} initial='hidden' whileInView={'show'} viewport={{ once: false, amount: 0.7 }} className='font-secondary font-medium text-[24px] lg:text-[32px] leading-[1] lg:ml-[-1px]'>
            Hello, <span>I am</span>
          </motion.h2>
          <motion.h1 variants={fadeIn('up', 0.3)} initial='hidden' whileInView={'show'} viewport={{ once: false, amount: 0.7 }} className='font-primary font-black text-[54px] lg:text-[90px] leading-[1.5] tracking-widest lg:ml-[-4px]'>
            MIRE <span>PATEL</span>
          </motion.h1>
          <motion.div variants={fadeIn('up', 0.4)} initial='hidden' whileInView={'show'} viewport={{ once: false, amount: 0.7 }} className='font-secondary font-semibold text-[36px] lg:text-[60px] leading-[1] lg:ml-[-3px] mb-6'>
            <span className='text-white mr-2 lg:mr-3'>I am a</span>
            <TypeAnimation
              sequence={[
                'Computer Engineer',
                2000,
                'Web Developer',
                2000,
                'Web Designer',
                2000,
              ]}
              speed={50}
              className='text-accent'
              wrapper='span'
              repeat={Infinity}
            />
          </motion.div>
          <motion.p variants={fadeIn('up', 0.5)} initial='hidden' whileInView={'show'} viewport={{ once: false, amount: 0.7 }} className='mb-8 max-w-lg mx-auto lg:mx-0'>
            Transforming Ideas into Engaging Web Solutions
          </motion.p>

          <motion.div variants={fadeIn('up', 0.6)} initial='hidden' whileInView={'show'} viewport={{ once: false, amount: 0.7 }} className='flex max-w-max gap-x-6 items-center mb-12 mx-auto lg:mx-0'>
            {/* <button className='btn btn-lg'>View Portfolio</button> */}
            {/* button */}
            <div className='flex flex-col space-y-4 lg:flex-row lg:space-y-0 lg:space-x-4'>
              <Link
                className='btn btn-lg cursor-pointer flex items-center justify-center sm:h-16'
                to='about'
                smooth={true}
                spy={true}
              >
                View Portfolio
              </Link>
              <a
                href='https://drive.google.com/uc?export=download&id=1Qp1xhXW5KZwM8Qc7Hv7PptVHM_5xA34E'
                className='btn-link sm:h-16'
                download
              >
                Download Resume
              </a>
            </div>

          </motion.div>

          {/* socials */}
          <motion.div variants={fadeIn('up', 0.7)} initial='hidden' whileInView={'show'} viewport={{ once: false, amount: 0.7 }} className='flex text-[20px] gap-x-6 max-w-max mx-auto lg:mx-0'>
            <a href='https://www.instagram.com/_mire_patel_/'>
              <GrInstagram />
            </a>
            <a href='https://www.facebook.com/mire.patel'>
              <FaFacebook />
            </a>
            <a href='https://www.linkedin.com/'>
              <FaLinkedin />
            </a>
            <a href='https://github.com/'>
              <FaGithub />
            </a>
          </motion.div>
        </div>

        {/* image */}
        <motion.div variants={fadeIn('down', 0.5)} initial='hidden' whileInView={'show'} className='hidden lg:flex flex-1 max-w-[320px] lg:max-w-[482px] mix-blend-luminosity'>
          <img src={Image} alt='Hero Section Img' />
        </motion.div>
      </div>
    </div >
  </section >
);

export default Banner;
